// Mock data for boxing camp website

export const mockPrograms = [
  {
    id: 1,
    title: "Beginner Boxing Fundamentals",
    level: "Beginner",
    description: "Perfect for those new to boxing. Learn proper stance, footwork, basic punches, and defensive techniques in a supportive environment.",
    duration: "60 minutes",
    price: 450,
    features: [
      "Basic boxing technique",
      "Footwork fundamentals",
      "Fitness conditioning",
      "Bag work training"
    ]
  },
  {
    id: 2,
    title: "Intermediate Fighter Development",
    level: "Intermediate",
    description: "Build on your foundation with advanced combinations, defensive maneuvers, and controlled sparring sessions.",
    duration: "75 minutes",
    price: 650,
    features: [
      "Advanced combinations",
      "Defensive techniques",
      "Light sparring",
      "Strength & conditioning"
    ]
  },
  {
    id: 3,
    title: "Advanced Fighter Camp",
    level: "Advanced",
    description: "Elite training for competitive boxers. Intense sparring, fight preparation, and personalized coaching.",
    duration: "90 minutes",
    price: 850,
    features: [
      "Competitive sparring",
      "Fight strategy",
      "Advanced conditioning",
      "1-on-1 coaching"
    ]
  },
  {
    id: 4,
    title: "Pro Fighter Intensive",
    level: "Professional",
    description: "Professional-level training for serious competitors. Complete fight camp preparation with personalized programs.",
    duration: "120 minutes",
    price: 1200,
    features: [
      "Full fight camp prep",
      "Personalized training",
      "Video analysis",
      "Nutrition guidance"
    ]
  },
  {
    id: 5,
    title: "Personal Training Sessions",
    level: "All Levels",
    description: "One-on-one personalized training tailored to your specific goals and skill level.",
    duration: "60 minutes",
    price: 950,
    features: [
      "Customized program",
      "Individual attention",
      "Flexible scheduling",
      "Progress tracking"
    ]
  }
];

export const mockCoaches = [
  {
    id: 1,
    name: 'Kent "The Fitness Doctor" Kalule',
    title: "Head Coach & Founder",
    experience: "15+ years",
    specialty: "Professional Boxing & Fight Strategy",
    credentials: [
      "Former Uganda National Novice and Intermediate Champion",
      "Certified Fitness Instructor",
      "Flyweight Professional Boxer"
    ],
    bio: "Kent brings world-class experience to every training session. With over 15 years in professional boxing and coaching, he's dedicated to developing champions at every level."
  },
  {
    id: 2,
    name: 'Freddie "Mr Cones" Kakooza',
    title: "Assistant Coach",
    experience: "10+ years",
    specialty: "Conditioning & Technical Training",
    credentials: [
      "Certified Sports Specialist",
      "Former Heavyweight Ugandan National Champion",
      "Fitness Coach in Kampala Uganda"
    ],
    bio: "Freddie specializes in building explosive power and endurance. His scientific approach to conditioning has transformed countless athletes into peak performers."
  }
];

export const mockTestimonials = [
  {
    id: 1,
    name: "Melissa Porter",
    role: "Fitness Enthusiast",
    rating: 5,
    text: "I've learnt a lot with Kent, he's a great coach even with kids. I recommend anyone and everyone who needs these classes, self-defense and the exercise is good for your health."
  },
  {
    id: 2,
    name: "Adriane Van Greunen",
    role: "Fitness Enthusiast",
    rating: 5,
    text: "If you want to learn boxing & ace it - this is the place to be. I caught on so quickly during my first session. The sessions are intense but so worth the reward. If you want a good workout & sense of achievement then I can't recommend Team Kent Boxing enough! The coaching is thorough & so worth it."
  },
  {
    id: 3,
    name: "Vuyie Baai",
    role: "Fitness Enthusiast",
    rating: 5,
    text: "I had really great experience with Kent; thorough teacher, great motivator, nice personality, teaches you in short time valuable technique adjustments, definitely would come back to him."
  }
];

export const mockTimeSlots = [
  "06:00 AM", "07:00 AM", "08:00 AM", "09:00 AM",
  "10:00 AM", "11:00 AM", "12:00 PM", "01:00 PM",
  "02:00 PM", "03:00 PM", "04:00 PM", "05:00 PM",
  "06:00 PM", "07:00 PM", "08:00 PM"
];

export const gymInfo = {
  name: "Team Kent Boxing International Gym",
  address: "60 Mackeurtan Ave, Durban North, Durban, 4051",
  email: "kent@teamkentboxing.co.za",
  phone: "+27 (0) 74 920 6557",
  hours: {
    weekday: "5:00 AM - 8:30 PM",
    saturday: "5:00 AM - 8:30 PM",
    sunday: "Closed",
    publicHolidays: "5:00 AM - 8:30 PM"
  }
};